"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var highcharts_1 = __importDefault(require("highcharts"));
var highcharts_more_1 = __importDefault(require("highcharts/highcharts-more"));
var bullet_1 = __importDefault(require("highcharts/modules/bullet"));
var heatmap_1 = __importDefault(require("highcharts/modules/heatmap"));
var solid_gauge_1 = __importDefault(require("highcharts/modules/solid-gauge"));
var legendItemColor_1 = __importDefault(require("./plugins/legendItemColor"));
require('./plugins/roundedPlotBand')(highcharts_1.default);
highcharts_more_1.default(highcharts_1.default);
bullet_1.default(highcharts_1.default);
heatmap_1.default(highcharts_1.default);
solid_gauge_1.default(highcharts_1.default);
legendItemColor_1.default(highcharts_1.default);
//# sourceMappingURL=HighchartsPlus.js.map